import { css } from "@emotion/css"

const styles = {
  wrapper: css`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  `,
  amount: css`
    display: block;
    margin: 6px 0;
    font-size: 20px;
    line-height: 1;
    font-weight: 900;
    //
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* max-width: 80%; */
  `,

  change: css`
    display: block;
    flex-shrink: 0;
    font-size: 13px;
  `,
}

export function Display(props: { amount: string; change?: string }) {
  const { amount, change } = props
  return (
    <div className={styles.wrapper}>
      <strong className={styles.amount} title={amount}>
        {amount}
      </strong>
      {change ? <small className={styles.change}>{change}</small> : <div />}
    </div>
  )
}
